

















import { defineComponent, ref, watch } from '@vue/composition-api';

const CommonToggleButton = defineComponent({
  props: {
    value: String,
    values: Array,
    labels: Array,
  },
  setup(props: any) {
    const _value = ref('');

    const getFirstAndLastClass = (index: number) => {
      if (index === props.values.length - 1) return 'rounded-r-lg';
      if (index === 0) return 'rounded-l-lg';
      return '';
    };

    const getActiveClass = (index: number) => {
      if (props.values[index] === _value.value) return 'fade-in active';
      return 'fade-out';
    };

    watch(() => props.value, (newVal) => {
      if (newVal !== _value.value) {
        _value.value = newVal;
      }
    });

    return {
      setLevel: (index: any) => { _value.value = props.values[index] as any; },
      getClass: (index: number) => `${getActiveClass(index)} ${getFirstAndLastClass(index)}`,
    };
  },
});

export default CommonToggleButton;
